// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__33gyZ","productName":"Table_productName__7BVmP"};